import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { useAuthProfile } from "../../../../utils/useAuthProfile";
import AuthProfile from "../model/AuthProfile";

// The API service function should not contain hooks
const fetchUserProfile = async (
  userProfile: AuthProfile | undefined
): Promise<AuthProfile | undefined> => {
  if (!userProfile) return undefined;
  const url = "/auth/user/";
  const { data } = await axios.get(url);
  return data;
};

const useAuthUserProfileApiService = (): UseQueryResult<
  AuthProfile | undefined,
  AxiosError
> => {
  // Move the useAuthProfile hook inside the custom hook
  const [userProfile] = useAuthProfile();

  return useQuery<AuthProfile | undefined, AxiosError>(
    ["AuthUserProfileApiService"],
    () => fetchUserProfile(userProfile),
    {
      cacheTime: 0, // Disable cache
      staleTime: 0, // Disable stale data
      refetchOnWindowFocus: true, // Refetch on window focus
      refetchInterval: false, // Disable automatic refetching
      // Only run the query if we have a user profile
      enabled: !!userProfile,
    }
  );
};

export default useAuthUserProfileApiService;
